/* eslint-disable max-lines */

import { minLength, maxLength, required } from 'vuelidate/lib/validators';
import ActionsDetail from '@/components/actions-detail/index.vue';
import DispatchersMixin from '@/mixins/dispatchers';
import ElementList from '@/components/element-list/index.vue';
import FormWatcher from '@/inheritance/form-watcher';
import LogoutMixin from '@/mixins/logout';


export default {
    name: 'PermissionSetDetails',

    mixins: [
        LogoutMixin,
        DispatchersMixin
    ],

    extends: FormWatcher,

    components: {
        ActionsDetail,
        ElementList
    },
    watch: {
        $route: {
            /**
             * Comprobamos con un watch si la URL ha cambiado y obtenemos los datos
             */
            handler() {
                this.saving = false;
                this.savingTitle = 'Guardar cambios';

                if (this.$route.name !== 'permission_set_add') {
                    // View/edit permission set
                    this.fetchData();
                } else {
                    // Si hay datos en el estado los cargamos
                    const storedComponentData = this.getStoredComponentData();
                    if (storedComponentData && Object.keys(storedComponentData).length) {
                        Object.entries(storedComponentData).forEach(([key, value]) => this[key] = value);
                    } else {
                        // Add permission set
                        this.form.permission = {
                            permission_actions: [],
                            permission_objects: []
                        };
                        this.fetchPermissions();
                    }
                }
            },
            immediate: true
        }
    },
    /**
     * @override
     */
    data() {
        return {
            saving: false,
            savingTitle: 'Guardar cambios',
            addUsers: false,
            usersNotInPermissionSet: [],
            loadingUsers: false,
            addGroups: false,
            groupsNotInPermissionSet: [],
            loadingGroups: false,
            submitted: false,
            allActions: false,
            allPermRead: false,
            allPermEdit: false,
            allPermDelete: false,
            allPermCreate: false,
            form: {
                key_name: null,
                display_name: null,
                description: null,
                permission: null
            },
            modalChangeSelfPermId: 'modalSelfPermChange',
            changingUser: null,
            removingPerm: null,
            modalRemovePermId: 'modalPermRemove',
            formWatcherProperties: ['form']
        };
    },
    props: {
        id: {
            type: String,
            required: false
        }
    },
    validations: {
        form: {
            display_name: {
                required,
                minLength: minLength(4),
                maxLength: maxLength(50)
            },
            description: {
                required
            }
        }
    },
    methods: {
        /**
         * Obtenemos la información del permiso
         */
        fetchData() {
            if (this.id) {
                this.loadPermission(this.id);
            } else {
                this.loadPermission(this.$route.params.uuid);
            }
        },
        /**
         * @override
         */
        switchAllActions() {
            this.allActions = !this.allActions;
            for (const action in this.form.permission.permission_actions) {
                if (action) {
                    this.form.permission.permission_actions[action].value = this.allActions;
                }
            }
        },
        /**
         * @override
         */
        switchAllPermission(type) {
            let value = false;
            let key = '';
            switch (type) {
                case 0:
                    value = this.allPermCreate = !this.allPermCreate;
                    key = 'add';
                    break;
                case 1:
                    value = this.allPermRead = !this.allPermRead;
                    key = 'read';
                    break;
                case 2:
                    value = this.allPermEdit = !this.allPermEdit;
                    key = 'edit';
                    break;
                case 3:
                    value = this.allPermDelete = !this.allPermDelete;
                    key = 'remove';
                    break;
                default:
                    break;
            }
            if (key !== 'read' && value === true) {
                this.allPermRead = true;
            } else if (key === 'read' && value === false) {
                this.allPermDelete = this.allPermEdit = this.allPermCreate = false;
            }
            for (const object in this.form.permission.permission_objects) {
                if (object) {
                    this.handleChange({ index: object, type: 'object', value, key });
                }
            }
        },
        /**
         * @override
         */
        fetchPermissions() {
            Promise.all([
                this.$permissionService.getPermissionsObjects(),
                this.$permissionService.getPermissionsActions()
            ]).then(res => {
                this.form.permission.permission_objects = res[0].data.permission_objects;
                this.form.permission.permission_objects = this.form.permission.permission_objects.map(x => {
                    return {
                        key_name: `${x.key_name}`,
                        value: { add: false, read: false, edit: false, remove: false }
                    };
                });
                this.form.permission.permission_actions = res[1].data.permission_actions;
                this.form.permission.permission_actions = this.form.permission.permission_actions.map(x => {
                    return {
                        key_name: `${x.key_name}`,
                        value: false
                    };
                });
            });
        },

        /**
         * Obtenemos el grupo desde el servicio
         * @param {String} uuid ID del grupo
         */
        loadPermission(uuid) {
            const cfg = {
                params: {
                    '$expand': 'users,groups'
                }
            };

            this.$permissionService.getPermissionByUUId(uuid, cfg)
                .then(response => {
                    this.form.permission = response.data.permission_set;
                    this.form.key_name = this.form.permission.key_name;
                    this.form.display_name = this.form.permission.display_name;
                    this.form.description = this.form.permission.description;
                    this.$store.dispatch('loaderStore/isVisible', false);
                    if (this.$route.name === 'permission_sets_uuid_duplicate') {
                        this.form.key_name = '';
                        this.form.description = '';
                        this.form.display_name = '';
                    }
                });
        },
        /**
         * Obtenemos usuarios que no están en el permission set
         * @param {String} uuid_permission_set ID del permission set
         * @param {String} str Texto a buscar
         */
        filterUsersNotInPermissionSet(uuid_permission_set, str = '') {
            this.loadingUsers = true;
            const filters = {
                'uuid_permission_set': [
                    { 'ne': `${uuid_permission_set}` }
                ]
            };
            if (str && str !== '') {
                filters['given_name'] = [
                    { 'in': `%${str}%` }
                ];
            }

            const cfg = {
                params: {
                    '$filter': JSON.stringify(filters)
                }
            };
            this.$usersService.getUsers('given_name asc', cfg)
                .then(res => {
                    this.usersNotInPermissionSet = res.data.users.map(x => {
                        return {
                            name: `${x.given_name} ${x.family_name_1} ${x.family_name_2 ? x.family_name_2 : ''}`,
                            uuid: x.uuid
                        };
                    });
                    this.loadingUsers = false;
                });
        },
        /**
         * Obtenemos grupos que no están en el permission set
         * @param {String} uuid_permission_set ID del permission set
         * @param {String} str Texto a buscar
         */
        filterGroupsNotInPermissionSet(uuid_permission_set, str = '') {
            this.loadingGroups = true;
            const filters = {
                'uuid_permission_set': [
                    { 'ne': `${uuid_permission_set}` }
                ]
            };
            if (str && str !== '') {
                filters['key_name'] = [
                    { 'in': `%${str}%` }
                ];
            }

            const cfg = {
                params: {
                    '$filter': JSON.stringify(filters)
                }
            };

            this.$groupsService.getGroups('key_name asc', cfg)
                .then(res => {
                    this.groupsNotInPermissionSet = res.data.groups.map(x => {
                        return {
                            name: `${x.key_name}`,
                            uuid: x.uuid
                        };
                    });
                    this.loadingGroups = false;
                });
        },
        /**
         * Guardamos la información del grupo
         * Marco como 'undefined' los objetos obtenidos por $expand
         * @param {Event} e FormEvent
         */
        onSubmit(e) {
            this.$v.$touch();
            this.submitted = true;
            e.preventDefault();
            if (this.$v.$invalid) {
                window.scrollTo(0, 0);
            } else {
                this.saving = true;
                this.savingTitle = 'Guardando...';
                delete this.form.permission.description;
                delete this.form.permission.display_name;
                delete this.form.permission.key_name;
                const formData = { ...this.form, ...this.form.permission };
                if (this.editable && this.$route.name !== 'permission_set_add' && this.$route.name !== 'permission_sets_uuid_duplicate') {
                    // Actualizamos permission set
                    this.$permissionService.update(formData)
                        .then(response => {
                            if (response.result && response.result.http_code !== 200) {
                                this.$toast.error(`Error ${response.result.http_code}`, `${response.result.info}`);
                            } else {
                                this.deleteStoredComponentData();
                                // Actualizar pestaña
                                this.updateItemMenu(response);
                            }
                        })
                        .catch(err => {
                            this.$toast.error(`Error ${err.name}`, `${err.message}`);
                        });
                    this.saving = false;
                    this.savingTitle = 'Guardar cambios';

                } else {
                    // Duplicamos y creamos permission set
                    e.preventDefault();
                    this.$permissionService.create(formData)
                        .then(response => {
                            if (response.result && response.result.http_code !== 200) {
                                this.$toast.error(`Error ${response.result.http_code}`, `${response.result.info}`);
                            } else {
                                this.deleteStoredComponentData();
                                this.handleRedirectAfterDuplication();
                            }
                        })
                        .catch(err => {
                            this.$toast.error(`Error ${err.name}`, `${err.message}`);
                        });
                    this.saving = false;
                }
            }

        },
        /**
        * Actualizar pestaña después de duplicar
        * si estamos en una subpestaña y no hay otras, la cerramos y volvemos al padre
        * si hay varias subpestañas, cerramos la actual y volvemos a la subpestaña anterior
        * si no estamos en una subpestaña cerramos la pestaña y volvemos al listado
         */
        handleRedirectAfterDuplication() {
            const indexActiveMenu = this.$store.getters['yuriMenuStore/activeItem'];
            const subItems = this.$store.getters['yuriMenuStore/activeItemChildrens'];

            if (subItems.length > 0) {
                const actualSubTabIndex = this.$store.getters['yuriMenuStore/activeSubItem'];
                this.$store.dispatch('yuriMenuStore/removeSubItem', actualSubTabIndex).then(() => {

                    if (subItems.length === 1) {
                        const parentItem = this.$store.getters['yuriMenuStore/items'][indexActiveMenu];
                        this.$router.push(parentItem.route);
                    } else {
                        const item = subItems[actualSubTabIndex - 1];
                        this.$store.dispatch('yuriMenuStore/setActiveSubItem', { indexActiveMenu, item })
                            .then(() => {
                                if (this.$route.query.id !== item.route.query.id
                                    || this.$route.name !== item.route.query.name) {
                                    this.$router.push(item.route);
                                }
                            });
                    }
                });
            } else {
                const items = this.$store.getters['yuriMenuStore/items'];
                const last = items.find(x => x.route.name === 'permission_set');
                if (last) {
                    this.$store.dispatch('yuriMenuStore/removeItem', indexActiveMenu).then(() => {
                        this.$store.dispatch('yuriMenuStore/setActiveItem', last).then(() => {
                            this.$router.replace(last.route);
                        });
                    });
                } else {
                    this.closeActiveTab('dashboard');
                }
            }
        },
        /**
         * @override
         */
        handleChange(payload) {
            if (payload.type === 'action') {
                this.form.permission.permission_actions[payload.index].value = payload.value;
            } else if (payload.type === 'object') {
                if (payload.value === 'true' || payload.value === true) {
                    this.form.permission.permission_objects[payload.index].value['read'] = true;
                    this.form.permission.permission_objects[payload.index].value[payload.key] = Boolean(payload.value);
                } else if (payload.key === 'read') {
                    Object.keys(this.form.permission.permission_objects[payload.index].value).forEach(perm => {
                        this.form.permission.permission_objects[payload.index].value[perm] = false;
                    });
                } else {
                    this.form.permission.permission_objects[payload.index].value[payload.key] = Boolean(payload.value);
                }
            }
        },
        /**
         * Si estamos editando un permission set volvemos a los detalles de este, de lo contrario cerramos el tab actual
         */
        handleCancel() {
            this.deleteStoredComponentData();
            if (this.id) {
                this.$router.push({ name: 'permission_sets_uuid', params: { uuid: this.id } });
            } else {
                const items = this.$store.getters['yuriMenuStore/items'];
                const indexActiveMenu = this.$store.getters['yuriMenuStore/activeItem'];
                const last = items.find(x => x.route.name === 'permission_set');
                if (last) {
                    this.$store.dispatch('yuriMenuStore/removeItem', indexActiveMenu).then(() => {
                        this.$store.dispatch('yuriMenuStore/setActiveItem', last).then(() => {
                            this.$router.replace(last.route);
                        });
                    });
                } else {
                    this.closeActiveTab('dashboard');
                }
            }
        },
        /**
         * Actualizamos la pestaña actual del menú con el nuevo nombre
         * @param {Object} res Resultado obtenido de la modificación para mostrar en el toast
         */
        updateItemMenu(res) {
            if (this.$route.meta && this.$route.meta.isView) {
                this.$store.dispatch('yuriMenuStore/updateSubItemName', this.form.key_name)
                    .then(() => {
                        this.savingTitle = '¡Guardado!';
                        const query = Object.assign({}, this.$route.query);
                        delete query.edit;
                        this.$router.replace({ query })
                            .then(() => this.$toast.success(`Success`, `${res.result.info}`));
                    });
            } else {
                this.$store.dispatch('yuriMenuStore/updateItemName', this.form.key_name)
                    .then(() => {
                        this.$toast.success(`Success`, `${res.result.info}`);
                        this.$router.go(-1);
                    });
            }
        },
        /**
         * On search-change event handler
         * @param {Object} event Search query
         */
        onFilterUser(event) {
            this.filterUsersNotInPermissionSet(this.form.permission.uuid, event);
        },
        /**
         * Shows multiselect to add users to group
         */
        showAddUsersSelect() {
            this.addUsers = !this.addUsers;
            this.filterUsersNotInPermissionSet(this.form.permission.uuid);
        },
        /**
         * Adds user to group
         * @param {Object} user Selected user
         */
        onSelectUser(user) {
            this.changingUser = user;
            if (JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem('BOCOUS'))))).user.uuid === user.uuid) {
                setTimeout(() => {
                    this.$bvModal.show(this.modalChangeSelfPermId);
                }, 1);
            } else {
                this.changeUserPermission(true);
            }
        },
        /**
         * @param {Boolean} accepts accept changes
         * @param {Object} user Selected user
         */
        changeUserPermission(accepts) {
            this.$bvModal.hide(this.modalChangeSelfPermId);
            if (accepts) {
                this.$usersService.changePermissionSet(this.changingUser.uuid, this.form.permission._links._self.href)
                    .then(res => {
                        this.usersNotInPermissionSet = this.usersNotInPermissionSet.filter(
                            x => x.uuid !== this.changingUser.uuid);
                        if (JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem('BOCOUS'))))).user.uuid === this.changingUser.uuid) {
                            this.logout();
                            this.$toast.success(`Success`, `${res.result.info}`);
                            this.$router.replace(`/login`);
                        } else {
                            this.loadPermission(this.form.permission.uuid);
                        }
                        this.changingUser = null;
                    });
            } else {
                this.changingUser = false;
            }
        },
        /**
         * @override
         */
        removePermissionSet() {
            this.removingPerm = true;
            setTimeout(() => {
                this.$bvModal.show(this.modalRemovePermId);
            }, 1);
        },
        /**
         * @override
         */
        removePermissionSetAccept(accepts) {
            if (accepts) {
                const uuid = this.id ? this.id : this.$route.params.uuid;
                this.$permissionService.deleteByUUIId(uuid)
                    .then(response => {
                        this.$toast.success(`${response.result.http_code}`, `${response.result.info || 'Permission set eliminado'}`);
                        // Subpestaña o pestaña
                        if (this.$route.meta && this.$route.meta.isView) {
                            this.$store.dispatch('yuriMenuStore/updateSubItemName', 'Permission sets');
                        } else {
                            const items = this.$store.getters['yuriMenuStore/items'];
                            const indexActiveMenu = this.$store.getters['yuriMenuStore/activeItem'];
                            const last = items.find(x => x.route.name === 'permission_set');
                            if (last) {
                                this.$store.dispatch('yuriMenuStore/removeItem', indexActiveMenu).then(() => {
                                    this.$store.dispatch('yuriMenuStore/setActiveItem', last).then(() => {
                                        this.$router.replace(last.route);
                                    });
                                });
                            } else {
                                this.closeActiveTab('dashboard');
                            }
                        }
                        this.$bvModal.hide(this.modalRemovePermId);
                        this.removingPerm = null;
                    })
                    .catch(err => {
                        this.$toast.error(err.name, err.message);
                        this.removingPerm = null;
                    });
            } else {
                this.removingPerm = false;
            }
        },
        /**
         * On search-change event handler
         * @param {Object} event Search query
         */
        onFilterGroup(event) {
            this.filterGroupsNotInPermissionSet(this.form.permission.uuid, event);
        },
        /**
         * Shows multiselect to add users to group
         */
        showAddGroupsSelect() {
            this.addGroups = !this.addGroups;
            this.filterGroupsNotInPermissionSet(this.form.permission.uuid);
        },
        /**
         * Adds user to group
         * @param {Object} group Selected user
         */
        onSelectGroup(group) {
            this.changingGroup = group;
            this.$groupsService.changePermissionSet(group.uuid, this.form.permission._links._self.href)
                .then(() => {
                    this.groupsNotInPermissionSet = this.groupsNotInPermissionSet.filter(x => x.uuid !== group.uuid);
                    this.loadPermission(this.form.permission.uuid);
                });
        }
    },
    computed: {
        /**
         * Indica si estamos editando un usuario o no
         * @return {Boolean} Editable true/false
         */
        editable() {
            if (this.actionObject('PERMISSION_SETS', 'edit')) {
                return this.$route.query.edit || this.$route.name === 'permission_sets_uuid_duplicate' || this.$route.name === 'permission_set_add' ? true : false;
            }
            return false;
        },
        /**
         * Devuelve un array de accione
         * @return {Array} Listado de acciones
         */
        actions() {
            return this.form.permission.permission_actions.map(perm => {
                const value = perm.value ? perm.value : false;
                return {
                    title: `${perm.key_name}`,
                    value: `${value}`
                };
            });
        },
        /**
         * Devuelve un array de objectos crud
         * @return {Array} Listado de objetos crud
         */
        objects() {
            return this.form.permission.permission_objects.map(action => {
                const value = action.value ? action.value : { add: false, read: false, edit: false, remove: false };
                return {
                    title: `${action.key_name}`,
                    value
                };
            });
        },
        /**
         * Permission set users list
         * @return {Array} users
         */
        users() {
            return this.form.permission.users.map(u => {
                return {
                    title: `${u.given_name} ${u.family_name_1} ${u.family_name_2 ? u.family_name_2 : ''}`,
                    uuid: u.uuid
                };
            });
        },
        /**
         * Permission set groups list
         * @return {Array} groups
         */
        groups() {
            return this.form.permission.groups.map(g => {
                return {
                    title: `${g.key_name}`,
                    uuid: g.uuid
                };
            });
        }
    },
    /**
     * Carga la información del permission set si se cambia de pestaña
     * @override
     */
    beforeMount() {
        this.saving = false;
        this.savingTitle = 'Guardar cambios1';

        if (this.$route.name !== 'permission_set_add') {
            // View/edit permission set
            this.fetchData();
        } else {
            // Si hay datos en el estado los cargamos
            const storedComponentData = this.getStoredComponentData();
            if (storedComponentData && Object.keys(storedComponentData).length) {
                Object.entries(storedComponentData).forEach(([key, value]) => this[key] = value);
            } else {
                // Add permission set
                this.form.permission = {
                    permission_actions: [],
                    permission_objects: []
                };
                this.fetchPermissions();
            }
        }
    }
};
